import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { IoIosArrowBack } from "react-icons/io";
import { TiThMenuOutline } from "react-icons/ti";
import '../../assets/css/Profile.css';

const PaymentHistory = () => {
    const payments = [
        { plan: "Standard", type: "Yearly plan", amount: "$94", date: "Oct-24" },
        { plan: "Platinum", type: "Yearly plan", amount: "$94", date: "Oct-23" },
        { plan: "Platinum", type: "Yearly plan", amount: "$94", date: "Sep-22" },
    ];

    return (
        <div className="mt-5 payement-history-wrapper" style={{height:'70vh'}}>
        <div className="row justify-content-center">
            <div className="p-4 w-100" >
                <div className="row w-100">
                    <div className="col-lg-5 d-flex justify-content-between w-100" style={{ marginBottom: '25px' }}>
                        <div className="mb-4 text-center w-100" style={{ fontSize: '20px', fontWeight: '600' }}>Payment History</div>
                    </div>
                </div>

                <div className="list-group d-flex justify-content-center">
                    {payments?.map((payment, index) => (
                        <div
                            key={index}
                            className="list-group-item d-flex justify-content-between align-items-center mb-4"
                        >
                            <div className="d-flex align-items-center">
                                <div className="me-3">
                                    <TiThMenuOutline style={{    fontSize: '27px'}}/>
                                </div>
                                <div>
                                    <div className="fw-bold">{payment.plan}</div>
                                    <div className="text-muted payment-type-text">{payment.type}</div>
                                </div>
                            </div>
                            <div className="text-end">
                                <div className="text-danger fw-bold">{payment.amount}</div>
                                <div className="text-muted payement-date">{payment.date}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
        </div>
    );
};

export default PaymentHistory;
